import { Box } from '@mui/material';
import * as React from 'react';
import LanguageTable from './languageTable';

export default function LanguageLayout() {
  return (
    <Box sx={{ mt: 2 }}>
      <LanguageTable />
    </Box>
  );
}
